import classNames from 'classnames';
import type { ReactNode } from 'react';
import styles from './LoadoutPanel.module.scss';

/** Which of the loadout's three panels to draw. */
export type LoadoutPanelSide = 'left' | 'center' | 'right';

interface LoadoutPanelProps {
    side: LoadoutPanelSide;
    /** The panel's content, laid out by `contentClassName`. */
    children?: ReactNode;
    /**
     * Draws a splitter over the panel's inner edge: the right edge of the
     * left panel, the left edge of the right panel. The splitter moves with
     * the panel.
     */
    splitter?: boolean;
    /** Classes for the panel itself, such as its width. */
    className?: string;
    /** Classes for the content box inside the frame, such as its grid. */
    contentClassName?: string;
}

/**
 * One of the loadout's three framed panels. Its frame is a border-image
 * with a fill; the content box sits inside the frame at the art's insets.
 */
export function LoadoutPanel({ side, children, splitter = false, className, contentClassName }: LoadoutPanelProps): JSX.Element {
    return (
        <div className={classNames(styles.panel, styles[side], className)}>
            <div className={classNames(styles.content, contentClassName)}>{children}</div>
            {splitter && <div className={styles.splitter} aria-hidden="true" />}
        </div>
    );
}
